//const ON_CHANGE_DEBOUNCE_TIMER = 300;

var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  //a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    if (
      selElmnt.options[selElmnt.selectedIndex].innerHTML ==
      selElmnt.options[j].innerHTML
    ) {
      c = document.createElement("DIV");
      c.classList.add("same-as-selected");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.setAttribute("tabindex", "0");
    } else {
      c = document.createElement("DIV");
      c.innerHTML = selElmnt.options[j].innerHTML;
      c.setAttribute("tabindex", "0");
    }
    c.addEventListener("click", function (e) {
      /* When an item is clicked, update the original select box,
        and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          //h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.parentElement.parentElement.previousElementSibling.classList.toggle(
      "select-arrow-active"
    );
  });
}

//function tab select checkbox
function handleKeyDown(event) {
  if (event.key === "Enter" || event.keyCode === 13) {
    this.click();
  }
}


const customSelect = document.querySelector(".custom-select");
const selectItems = document.querySelector(".select-items");
const selectItemsChildren = document.querySelectorAll(".custom-select .select-items");
let timeoutId;

function handleFocusIn() {
  clearTimeout(timeoutId);
  selectItems.classList.remove("select-hide");
  document.querySelector('.facet-filters__label.text-body').classList.add("select-arrow-active"); 
}

function handleFocusOut() {
  timeoutId = setTimeout(() => {
    selectItems.classList.add("select-hide");
    document.querySelector('.facet-filters__label.text-body').classList.remove("select-arrow-active");
  }, 100); // Задержка в миллисекундах
}

for (let i = 0; i < selectItemsChildren.length; i++) {
  selectItemsChildren[i].addEventListener("focusin", handleFocusIn);
  selectItemsChildren[i].addEventListener("focusout", handleFocusOut);
}

customSelect.addEventListener('keydown', function() {
  if (event.key === "Enter" || event.keyCode === 13) {
    selectItems.classList.remove("select-hide");
    document.querySelector('.facet-filters__label.text-body').classList.add("select-arrow-active"); 
  }
})

document.querySelectorAll(".custom-select .select-items div").forEach((item)=> {
  item.addEventListener('keydown', function() {
    if (event.key === "Enter" || event.keyCode === 13) {
      item.click();
      setTimeout(()=> {
        selectItems.classList.add("select-hide");
        document.querySelector('.facet-filters__label.text-body').classList.remove("select-arrow-active"); 
      }, 200)
    }
  })
})



function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
      document
        .querySelector(".facet-filters__label")
        .classList.remove("select-arrow-active");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    var elem = document.querySelector(".product-grid-container");

    const facetForm = this.querySelectorAll("form input:not(.pr), form select");
    facetForm.forEach((item) => {
      item.addEventListener("change", this.debouncedOnSubmit.bind(this));
    });

    document
      .querySelector(".set-price")
      .addEventListener("click", this.debouncedOnSubmit.bind(this));

    document.querySelector(".set-option").addEventListener("click", () => {
      document.querySelector(".set-price").click();
    });

    let observer = new MutationObserver((mutationRecords) => {
      const facetForm = this.querySelectorAll("form input:not(.pr)");
      facetForm.forEach((item) => {
        item.addEventListener("change", this.debouncedOnSubmit.bind(this));
      });

      document
        .querySelector(".set-price")
        .addEventListener("click", this.debouncedOnSubmit.bind(this));

      //clear input
      document
        .querySelector(".button-price .set-remove")
        .addEventListener("click", function (e) {
          e.preventDefault();
          clearInput();
          this.parentElement.classList.add("disabled");
        });

        function clearInput() {
          if (document.querySelectorAll(".facets__item.checked").length) {
            document
              .querySelector(".facets__item.checked")
              .classList.remove("checked");
          }
          var input = document.querySelectorAll(".facets__price input");
          input.forEach((inp) => {
            inp.value = "";
          });
        }

        document.querySelectorAll("#FacetsWrapperDesktop .facets__item input").forEach((item) => {
          // Удаляем существующий обработчик события
          item.removeEventListener('keydown', handleKeyDown);
        
          // Добавляем новый обработчик события
          item.addEventListener('keydown', handleKeyDown);
        });
        
        
        
        
       
    });

    //stoped form
    var inputFieldMin = document.querySelector('.field__input.min-input');
    var inputFieldMax = document.querySelector('.field__input.max-input');

    function hideKeyboard() {
      inputFieldMin.blur();
      inputFieldMax.blur();
    }
    document.querySelector('#FacetFiltersForm').addEventListener('submit', function(e) {
      e.preventDefault();
      document.querySelector('.set-price').click();
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.querySelector(".left-filter").classList.remove("show");
        document.querySelector("body").classList.remove("overflow-stop");
        document.querySelector(".facets-vertical").classList.remove("open");
        hideKeyboard();
      }
      //document.querySelector('.active-facets .close-filter').click()
    })

    observer.observe(elem, {
      childList: true,
      subtree: true,
      characterDataOldValue: true,
    });

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }
    

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    //check input
    checkInput();

    document.querySelectorAll(".facets__price input").forEach((el) => {
      el.addEventListener("input", function () {
        checkInput();
      });
    });

    function checkInput() {
      var input = document.querySelectorAll(".facets__price input");
      var summString = "";
      input.forEach((inp) => {
        summString = summString + inp.value;
      });
      if (summString.length != "") {
        document.querySelector(".button-price").classList.remove("disabled");
        document
          .querySelector(".button-price")
          .previousElementSibling.classList.remove("disabled-input");
      } else {
        document.querySelector(".button-price").classList.add("disabled");
        document
          .querySelector(".button-price")
          .previousElementSibling.classList.add("disabled-input");
      }
    }

    function clearInput() {
      if (document.querySelectorAll(".facets__item.checked").length) {
        document
          .querySelector(".facets__item.checked")
          .classList.remove("checked");
      }
      var input = document.querySelectorAll(".facets__price input");
      input.forEach((inp) => {
        inp.value = "";
      });
    }

    //Checked price
    const container = document.querySelector(".filter__price");

    function minAndMaxInput() {
      var event = new Event("input");
      var elem = document.querySelector(".min-input");
      let arrayPrice = [];

      if (document.querySelectorAll(".filter__price .checked").length) {
        document.querySelectorAll(".filter__price .checked").forEach((el) => {
          arrayPrice.push(Number(el.getAttribute("data-min")));
          arrayPrice.push(Number(el.getAttribute("data-max")));
        });
        let smallest = Math.min(...arrayPrice);
        let largest = Math.max(...arrayPrice);

        document.querySelector(".min-input").value = smallest;
        document.querySelector(".max-input").value = largest;
        elem.dispatchEvent(event);
      } else {
        clearInput();
      }

      checkInput();

    }

    if(!document.querySelectorAll('.listener').length) {
      container.addEventListener("click", function priceClick(e) {
        const target = e.target;
        if (target.classList.contains("checked")) {
          target.classList.remove("checked");
          minAndMaxInput();
        } else {
          target.classList.add("checked");
          minAndMaxInput();
        }
  
        document.querySelector(".set-price").click();
      });

      container.addEventListener("keydown", function priceClick(e) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const target = e.target;
          if (target.classList.contains("checked")) {
            target.classList.remove("checked");
            minAndMaxInput();
          } else {
            target.classList.add("checked");
            minAndMaxInput();
          }
    
          document.querySelector(".set-price").click();
        }
      });

      container.classList.add('listener');
    }


    //ajax pagination
    function pagAjax() {
      document.querySelectorAll(".pages ol a").forEach((item) => {
        const parser = new DOMParser();
        item.addEventListener("click", function (e) {
          e.preventDefault();
          let page = this.getAttribute("href");
          document
            .querySelector(".collection.category-products")
            .classList.add("loading");
          fetch(page)
            .then((response) => {
              return response.text();
            })
            .then((data) => {
              const newDate = parser.parseFromString(data, "text/html");
              document
                .querySelector(".filtering-page")
                .replaceWith(newDate.querySelector(".filtering-page"));
            })
            .then(() => {
              const yOffset = document.querySelector("header").clientHeight;
              const element = document.querySelector(".collection-filtering");
              const y =
                element.getBoundingClientRect().top +
                window.pageYOffset -
                yOffset;
  
              window.scrollTo({ top: y, behavior: "smooth" });
              pagAjax();
            });
        });
      });
    }

    pagAjax();
    
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets-desktop"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      document
        .querySelector(".set-price")
        .addEventListener("click", function (e) {
          e.preventDefault();
        });
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    button.addEventListener("click", (event) => {
      this.expandShowMore(event);
      const nextElementToFocus = event.target
        .closest(".parent-display")
        .querySelector(".show-more-item");
      if (
        nextElementToFocus &&
        !nextElementToFocus.classList.contains("hidden")
      ) {
        nextElementToFocus.querySelector("input").focus();
      }
    });
  }
  expandShowMore(event) {
    const parentDisplay = event.target
      .closest('[id^="Show-More-"]')
      .closest(".parent-display");
    const parentWrap = parentDisplay.querySelector(".parent-wrap");
    this.querySelectorAll(".label-text").forEach((element) =>
      element.classList.toggle("hidden")
    );
    parentDisplay
      .querySelectorAll(".show-more-item")
      .forEach((item) => item.classList.toggle("hidden"));
  }
}

customElements.define("show-more-button", ShowMoreButton);

document.addEventListener("DOMContentLoaded", function () {
  //show and hide filter
  function openFilEnter(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      document.querySelector(".left-filter").classList.toggle("show");
      document.querySelector("body").classList.toggle("overflow-stop");
      if (
        document.querySelector(".filter-utils span").innerHTML === "Show Filter"
      ) {
        document.querySelector(".filter-utils span").innerHTML = "Hide Filter";
        document.querySelector(".facets-vertical").classList.add("open");
      } else {
        document.querySelector(".filter-utils span").innerHTML = "Show Filter";
        document.querySelector(".facets-vertical").classList.remove("open");
      }

      
      document.querySelector(".filter-func.filter-utils").focus();
    }
  }
  function openFilMouse() {
    document.querySelector(".left-filter").classList.toggle("show");
    document.querySelector("body").classList.toggle("overflow-stop");
    if (
      document.querySelector(".filter-utils span").innerHTML === "Show Filter"
    ) {
      document.querySelector(".filter-utils span").innerHTML = "Hide Filter";
      document.querySelector(".facets-vertical").classList.add("open");
    } else {
      document.querySelector(".filter-utils span").innerHTML = "Show Filter";
      document.querySelector(".facets-vertical").classList.remove("open");
    }
  }
  document.querySelectorAll(".filter-func").forEach((el) => {
    el.addEventListener("click", openFilMouse);
    el.addEventListener("keypress", openFilEnter);
  });

  document.querySelectorAll(".close-filter").forEach((el) => {
    el.addEventListener("keypress", openFilEnter);
  });

  document.querySelectorAll("#FacetsWrapperDesktop details").forEach((el) => {
    el.addEventListener('keydown', function() {
      if (event.key === 'Escape') {
        document.querySelector(".left-filter").classList.toggle("show");
        document.querySelector("body").classList.toggle("overflow-stop");
        if (
          document.querySelector(".filter-utils span").innerHTML === "Show Filter"
        ) {
          document.querySelector(".filter-utils span").innerHTML = "Hide Filter";
          document.querySelector(".facets-vertical").classList.add("open");
        } else {
          document.querySelector(".filter-utils span").innerHTML = "Show Filter";
          document.querySelector(".facets-vertical").classList.remove("open");
        }
        
        document.querySelector(".filter-func.filter-utils").focus();
      }
    })
  });

  //Checked price
  const container = document.querySelector(".filter__price");

  function minAndMaxInput() {
    var event = new Event("input");
    var elem = document.querySelector(".min-input");
    let arrayPrice = [];

    if (document.querySelectorAll(".filter__price .checked").length) {
      document.querySelectorAll(".filter__price .checked").forEach((el) => {
        arrayPrice.push(Number(el.getAttribute("data-min")));
        arrayPrice.push(Number(el.getAttribute("data-max")));
      });
      let smallest = Math.min(...arrayPrice);
      let largest = Math.max(...arrayPrice);

      document.querySelector(".min-input").value = smallest;
      document.querySelector(".max-input").value = largest;
      elem.dispatchEvent(event);
    } else {
      clearInput();
    }

    checkInput();

    
  }

  
  container.classList.add('listener');
  container.addEventListener("click", function priceClick(e) {
    const target = e.target;
    if (target.classList.contains("checked")) {
      target.classList.remove("checked");
      minAndMaxInput();
    } else {
      target.classList.add("checked");
      minAndMaxInput();
    }

    document.querySelector(".set-price").click();
  });

  container.addEventListener("keydown", function priceClick(e) {
    if (event.key === "Enter" || event.keyCode === 13) {
      const target = e.target;
      if (target.classList.contains("checked")) {
        target.classList.remove("checked");
        minAndMaxInput();
      } else {
        target.classList.add("checked");
        minAndMaxInput();
      }

      document.querySelector(".set-price").click();
    }
  });

  //check input
  checkInput();

  document.querySelectorAll(".facets__price input").forEach((el) => {
    el.addEventListener("input", function () {
      checkInput();
    });
  });

  function checkInput() {
    var input = document.querySelectorAll(".facets__price input");
    var summString = "";
    input.forEach((inp) => {
      summString = summString + inp.value;
    });
    if (summString.length != "") {
      document.querySelector(".button-price").classList.remove("disabled");
      document
        .querySelector(".button-price")
        .previousElementSibling.classList.remove("disabled-input");
    } else {
      document.querySelector(".button-price").classList.add("disabled");
      document
        .querySelector(".button-price")
        .previousElementSibling.classList.add("disabled-input");
    }
  }

  //clear input
  document
    .querySelector(".button-price .set-remove")
    .addEventListener("click", function (e) {
      e.preventDefault();
      clearInput();
      this.parentElement.classList.add("disabled");
    });

  function clearInput() {
    if (document.querySelectorAll(".facets__item.checked").length) {
      document.querySelectorAll(".facets__item.checked").forEach(function(item) {
        item.classList.remove("checked");
      });
    }
    var input = document.querySelectorAll(".facets__price input");
    input.forEach((inp) => {
      inp.value = "";
    });
  }

  document.querySelector(".custom-select").addEventListener("click", function () {
      var event = new Event("change");
      var elem = document.querySelector(".facet-filters__sort");
      elem.dispatchEvent(event);
    });

    document.querySelectorAll("#FacetsWrapperDesktop .facets__item input").forEach((item) => {
      // Удаляем существующий обработчик события
      item.removeEventListener('keydown', handleKeyDown);
    
      // Добавляем новый обработчик события
      item.addEventListener('keydown', handleKeyDown);
    });

  
    //ajax pagination
    function pagAjax() {
      document.querySelectorAll(".pages ol a").forEach((item) => {
        const parser = new DOMParser();
        item.addEventListener("click", function (e) {
          e.preventDefault();
          let page = this.getAttribute("href");
          document.querySelector(".collection.category-products").classList.add("loading");
          fetch(page)
            .then((response) => {
              return response.text();
            })
            .then((data) => {
              const newDate = parser.parseFromString(data, "text/html");
              document.querySelector(".filtering-page").replaceWith(newDate.querySelector(".filtering-page"));
            })
            .then(() => {
              const yOffset = document.querySelector("header").clientHeight;
              const element = document.querySelector(".collection-filtering");
              const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;
  
              window.scrollTo({ top: y, behavior: "smooth" });
              pagAjax();

              //History push state new link
              var newUrl = window.location.origin + page;
              history.pushState(null, null, newUrl);
              //END - history push state new link
            });
        });
      });
    }

    pagAjax();
});
